// Worksheep offers two curricula. Most teachers never touch the switch, so the default
// decides whether a US teacher gets Common Core and dollars or the UK curriculum and pounds.
const US_CURRICULUM_COUNTRIES = new Set(["US", "CA", "PR"]);

function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return null;
  }
}

// country: ISO code from the teacher's profile, when they've given one. Otherwise the
// browser's time zone is the best hint (most profiles have no country).
export function pickRegion(country, timeZone = browserTimeZone()) {
  if (country) return US_CURRICULUM_COUNTRIES.has(country.toUpperCase()) ? "US" : "UK";
  return timeZone?.startsWith("America/") ? "US" : "UK";
}
